import { BarChart3, FileText, Radar, Repeat } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { useLang } from "@/i18n/LangContext";

const ICONS = [FileText, BarChart3, Radar, Repeat];

export const AiSection = () => {
  const { t } = useLang();
  const a = t.home.ai;
  return (
  <section className="relative overflow-hidden bg-ink px-5 md:px-10 py-24 md:py-32 text-cream grain" data-testid="ai-section">
    <div className="absolute -top-32 right-0 w-96 h-96 rounded-full bg-terracotta/15 blur-3xl" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl">
      <div className="max-w-3xl">
        <SectionTag light>{a.tag}</SectionTag>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-balance">
            {a.h2}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-cream/70">
            {a.subtitle}
          </p>
        </Reveal>
      </div>
      <div className="mt-14 md:mt-20 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {a.uses.map((u, i) => {
          const Icon = ICONS[i];
          return (
          <Reveal key={u.title} delay={i * 0.08}>
            <div className="h-full rounded-3xl border border-cream/10 bg-cream/5 p-7 backdrop-blur transition-colors duration-500 hover:bg-cream/10">
              <Icon className="w-6 h-6 text-terracotta" strokeWidth={1.75} aria-hidden="true" />
              <h3 className="mt-4 font-display text-lg font-bold tracking-tight">{u.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/65">{u.text}</p>
            </div>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
